import { render, staticRenderFns } from "./prinCount.vue?vue&type=template&id=0bc7cea4&scoped=true"
import script from "./prinCount.vue?vue&type=script&lang=js"
export * from "./prinCount.vue?vue&type=script&lang=js"
import style0 from "./prinCount.vue?vue&type=style&index=0&id=0bc7cea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7cea4",
  null
  
)

export default component.exports